import script from "./indicatorParams.vue?vue&type=script&setup=true&lang=ts"
export * from "./indicatorParams.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__